<!-- 
* @description
  * 面包屑组件：
  * 显示规则：当前路由树下，除根节点开始显示到当前页面层级
  * 操作规则：父级有的面包屑可以点击跳转回上一级，否则只做显示
  * 数据渲染：后端路由结构动态渲染，监听路有变化更新
-->
<template>
  <div class="zhzw-breadcrumb">
    <transition name="slide-fade">
      <span v-if="parentPath"
        class="pointer color-main font-weight-500 return"
        @click="routerPush">返回上一级</span>
    </transition>
    <el-breadcrumb separator="/"
      class="breadcrumb-inner">
      <template v-for="(item, key) in breadcrumb">
        <el-breadcrumb-item v-if="item.meta.isBread && key < breadcrumb.length - 1"
          :key="key"
          :to="{ path: item.path, query: item.query }">{{item.meta.label}}</el-breadcrumb-item>
        <el-breadcrumb-item v-else
          :key="key">{{item.meta.label}}</el-breadcrumb-item>
      </template>
    </el-breadcrumb>
  </div>
</template>

<script>
export default {
  name: 'breadcrumb',
  props: {
    queryHistory: {
      default: false
    }
  },
  data() {
    return {
      breadcrumb: [],
      parentPath: null,
      parentQuery: null,
      parentIndex: null
    }
  },
  watch: {
    "$route.path"(val) {
      this.updateBreadcrumb();
    },
  },
  mounted() {
    this.updateBreadcrumb()
  },
  methods: {
    routeQuery(path) {
      if (this.queryHistory) {
        return this.$store.state.routeQuery[path]
      }
      return {}
    },
    updateBreadcrumb() {
      this.breadcrumb = this.$route.matched.filter((elem) => (Object.keys(elem.meta).length > 0 && elem.meta.label))
      let index = this.breadcrumb.findIndex((elem) => elem.path === this.$route.path)
      this.$set(this.breadcrumb[index], 'query', this.$route.query)
      // 找到当前路由的上一个路由，也就是当前路由的父路由，如果副路由可被点击则找到地址并赋值展示“返回上一级”的按钮
      this.parentPath = (index > 0 && this.breadcrumb[index - 1].meta.isBread) ? this.breadcrumb[index - 1].path : null
      // this.parentQuery = (index > 0 && this.breadcrumb[index - 1].query) ? this.breadcrumb[index - 1].query : null
      this.parentIndex = index > 0 ? index - 1 : null
    },
    routerPush() {
      this.$router.push({ path: this.parentPath, query: this.parentIndex ? this.breadcrumb[this.parentIndex].query : null })
    }
  }
}
</script>

<style  lang="scss">
.zhzw-breadcrumb {
  height: 28px;
  display: flex;
  flex-direction: row;
  align-items: center;
  .el-breadcrumb {
    display: inline-block;
  }
  .return {
    position: relative;
    padding-right: 20px;
    &::before {
      position: absolute;
      display: block;
      content: "";
      width: 1px;
      height: 12px;
      background: $color-font-placeholder;
      border-radius: 2px;
      right: 10px;
      top: 4px;
    }
  }
}

// .slide-fade-enter-active,
// .slide-fade-leave-active {
//   transition: all 0.2s ease;
// }
// // .slide-fade-leave-active {
// //   transition: all 0.3s ease;
// // }
// .slide-fade-enter, .slide-fade-leave-to
// /* .slide-fade-leave-active for below version 2.1.8 */ {
//   transform: translateX(3px);
//   opacity: 0;
// }
</style>


// WEBPACK FOOTER //
// ../vue-common-laboratory/src/components/common/Breadcrumb.vue